// src/components/gen-application/GeneralApplicationLogin.js
import React, { useContext, memo } from "react";
import { SettingsContext } from "../../context/SettingsContext";
import ApplicationHeader from "./ApplicationHeader";
import ApplicationLoginBlock from "./ApplicationLoginBlock";
import ApplicationInfo from "./ApplicationInfo";

function ApplicationLogin() {
  const { settings } = useContext(SettingsContext);
  // console.log("isAuthenticated:", isAuthenticated);

  const noticeMessage = settings["Notice"] ? settings["Notice"] : null;
  const generalClose = settings["GeneralClose"]
    ? settings["GeneralClose"].settingDate
    : null;
  const dasClose = settings["DASClose"]
    ? settings["DASClose"].settingDate
    : null;

  return (
    <div className="applications-login-page">
      <ApplicationHeader
        generalClose={generalClose}
        noticeMessage={noticeMessage}
        dasClose={dasClose}
      />
      <ApplicationLoginBlock />
      <ApplicationInfo />
    </div>
  );
}

export default memo(ApplicationLogin);
